import { reflect } from '@effector/reflect';
import { Box, BoxProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { accountTreeModel } from 'entities/account';
import { translated } from 'shared/lib';
import {
	accountsRoute,
	cashdesksRoute,
	accountRoute,
	gameSettingsRoute,
	usersRoute,
	gamesRoute,
	accountsReportRoute,
	shiftsReportRoute,
	jackpotsRoute,
	bonusesRoute,
	betsReportRoute,
} from 'shared/routing';
import { NavList, NavMenu } from 'shared/ui';
import cls from './admin-layout-nav-menu.module.scss';

const AccountancyNavListItem = reflect({
	view: NavList.Item,
	bind: {
		'data-test-id': 'admin-layout-accountancy',
		to: accountRoute,
		query: accountTreeModel.$singleSelectedNode.map((id) => (id ? { id } : null)),
		children: translated('admin-layout.accountancy'),
	},
});

export const AdminLayoutNavMenu = ({ ...props }: BoxProps) => {
	const { t } = useTranslation();

	return (
		<Box
			component='nav'
			className={cls.adminLayoutNavMenu}
			{...props}
		>
			<AccountancyNavListItem />
			<NavList.Item
				to={accountsRoute}
				data-test-id='admin-layout-accounts'
			>
				{t('admin-layout.accounts')}
			</NavList.Item>
			<NavList.Item
				to={cashdesksRoute}
				data-test-id='admin-layout-cashdesks'
			>
				{t('admin-layout.cashdesks')}
			</NavList.Item>
			<NavList.Item
				to={usersRoute}
				data-test-id='admin-layout-users'
			>
				{t('admin-layout.users')}
			</NavList.Item>
			<NavList.Item
				to={gamesRoute}
				data-test-id='admin-layout-games'
			>
				{t('admin-layout.games')}
			</NavList.Item>
			<NavMenu label={t('admin-layout.settings')}>
				<NavMenu.Item
					to={gameSettingsRoute}
					data-test-id='admin-layout-game-settings'
				>
					{t('admin-layout.game-settings')}
				</NavMenu.Item>
				<NavMenu.Item
					to={jackpotsRoute}
					data-test-id='admin-layout-jackpots'
				>
					{t('admin-layout.jackpots')}
				</NavMenu.Item>
				<NavMenu.Item
					to={bonusesRoute}
					data-test-id='admin-layout-bonuses'
				>
					{t('admin-layout.bonuses')}
				</NavMenu.Item>
			</NavMenu>
			<NavMenu label={t('admin-layout.reports')}>
				<NavMenu.Item
					to={accountsReportRoute}
					data-test-id='admin-layout-accounts-report'
				>
					{t('admin-layout.accounts-report')}
				</NavMenu.Item>
				<NavMenu.Item
					to={shiftsReportRoute}
					data-test-id='admin-layout-shifts-report-link'
				>
					{t('admin-layout.shifts-report')}
				</NavMenu.Item>
				<NavMenu.Item
					to={betsReportRoute}
					data-test-id='admin-layout-bets-report'
				>
					{t('admin-layout.bets-report')}
				</NavMenu.Item>
				{/* <NavMenu.Item to={reviewReportRoute}>{t('admin-layout.review-report')}</NavMenu.Item>
				<NavMenu.Item to={dailyReportRoute}>{t('admin-layout.daily-report')}</NavMenu.Item>
				<NavMenu.Item to={detailedReportRoute}>{t('admin-layout.detailed-report')}</NavMenu.Item>
				<NavMenu.Item to={sessionsReportRoute}>{t('admin-layout.cashiers-report')}</NavMenu.Item>
				<NavMenu.Item to={devicesReportRoute}>{t('admin-layout.device-report')}</NavMenu.Item> */}
			</NavMenu>
		</Box>
	);
};
